module.exports = __webpack_public_path__ + "img/top.0cfeb4dd.gif";